type Props = { src: string } & JSX.HTMLAttributes<HTMLImageElement>

const Img: FC<Props> = ({ src, ...p }) => {
	return <img src={src} srcSet={src?.replace(/\.(png|jpg|jpeg)$/, '.webp')} alt='' {...p} />
}
export default Img
